import { Text, Flex, Button } from "@chakra-ui/react";
import { Modal } from "@/components/Modal";
import { colors } from "@/theme/colors";

// On-brand confirmation dialog — replaces the native browser confirm().
export const ConfirmModal = ({ open, onClose, title, body, confirmLabel, danger, busy, onConfirm, testId = "confirm-modal" }) => (
  <Modal open={open} onClose={onClose} title={title} testId={testId}>
    <Text fontSize="sm" color={colors.textSecondary} mb="6" whiteSpace="pre-line" data-testid="confirm-body">{body}</Text>
    <Flex gap="3" justify="flex-end">
      <Button variant="outline" size="sm" onClick={onClose} data-testid="confirm-cancel-btn">Cancel</Button>
      <Button variant={danger ? "danger" : "solid"} size="sm" loading={busy} onClick={onConfirm} data-testid="confirm-action-btn">
        {confirmLabel}
      </Button>
    </Flex>
  </Modal>
);
